import React, { useEffect, useState } from "react";
import "./style.css";
import { circleIcon } from "./../icons";

import Box from "@mui/material/Box";
import Slider from "@mui/material/Slider";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  InputLabel,
  NativeSelect,
  Tooltip,
} from "@mui/material";
import { valueLabelFormat } from "../utils/sliderFunctions";
import { circleChecked, circleUnchecked } from "../icons";
const ComissionCalculator = ({
  setCalc,
  setPrice,
  setDueDiligenceTimeline,
  setCalcIndividual,
  setCheckboxState,
  checkboxState,
  price,
}) => {
  const [monthly, setMonthly] = useState(true);

  const handleCanculate = (e) => {
    setCalc((prev) => !prev);
    setCalcIndividual(() => (monthly ? true : false));
  };
  const handleChangeIndividual = () => {
    setCalcIndividual((prev) => !prev);
  };

  const marks = [
    {
      value: 300000,
      label: "$300K",
    },

    {
      value: 25000000,
      label: "$25M",
    },
  ];
  function valuetext(value) {
    return `$${value}M`;
  }

  // const [checkboxState, setCheckboxState] = React.useState({
  //   pv: true,
  //   lvp: true,
  //   tsa: false,
  //   qoe: false,
  //   df: false,
  // });

  const handleCheckboxChange = (event) => {
    setCheckboxState({
      ...checkboxState,
      [event.target.name]: event.target.checked,
    });
  };

  const { pv, lvp, tsa, qoe, df } = checkboxState;
  return (
    <div className='comission-calculator'>
      <h1>Generate a Quote</h1>
      <p></p>
      <div className='change-price'>
        <a>
          <button
            className={`${monthly ? 'active' : ''} `}
            onClick={() => {
              setMonthly(true)
              handleChangeIndividual(true)
            }}
          >
            {monthly ? circleChecked : circleUnchecked} Individual Service
          </button>
        </a>
        <a>
          <button
            className={`${!monthly ? 'active' : ''} `}
            onClick={() => {
              setMonthly(false)
              handleChangeIndividual(false)
            }}
          >
            {!monthly ? circleChecked : circleUnchecked}Start to Finish Plan
          </button>
        </a>
      </div>
      <div className='calculator-box'>
        <div>
          {monthly ? (
            <div>
              <label htmlFor='price'>
                Business Purchase Price
                <Tooltip
                  title='We use this to determine our base pricing. Businesses listed at $300K or less qualify for our base pricing. For businesses larger than $25M, please contact us.'
                  placement='right'
                >
                  {circleIcon}
                </Tooltip>
              </label>
              <div className='input-price list-price'>
                <div>
                  <Slider
                    aria-label='Always visible'
                    defaultValue={300000}
                    getAriaValueText={valuetext}
                    valueLabelDisplay='auto'
                    marks={marks}
                    // value={price}
                    step={100000}
                    min={300000}
                    max={25000000}
                    valueLabelDisplay={'on'}
                    onChange={(e) => setPrice(() => e.target.value)}
                    getAriaValueText={valueLabelFormat}
                    valueLabelFormat={valueLabelFormat}
                  />
                </div>
              </div>
              <br />
              <div>
                <div>
                  <Box sx={{ minWidth: 120 }}>
                    <FormControl fullWidth>
                      <InputLabel
                        className='label-due'
                        variant='standard'
                        htmlFor='uncontrolled-native'
                      >
                        Due Diligence Timeline
                        <Tooltip
                          title='We deliver all reports within 3-4 weeks. If you require a quicker turnaround time, expediting fees are 15% for one week and 10% for two weeks, when possible. Your quote will be inclusive of any expediting fees.'
                          placement='right'
                        >
                          {circleIcon}
                        </Tooltip>
                      </InputLabel>
                      <NativeSelect
                        onChange={(e) => {
                          setDueDiligenceTimeline(e.target.value)
                        }}
                        defaultValue={'3-4 weeks'}
                        inputProps={{
                          name: 'age',
                          id: 'uncontrolled-native',
                        }}
                      >
                        <option value={'1 week'}>1 week</option>
                        <option value={'2 weeks'}>2 weeks</option>
                        <option value={'3-4 weeks'}>3-4 weeks</option> // This
                        registers as 1 because we set it as the default value
                        <option value={'4+ weeks'}>4+ weeks</option>
                      </NativeSelect>
                    </FormControl>
                  </Box>
                </div>
              </div>
            </div>
          ) : (
            <div>
              <label htmlFor='price'>
                Target Purchase Price
                <Tooltip
                  title='We use this to determine our base pricing. Feel free to take your best guess as this can be modified later. If you are looking to acquire a business listed at $300K or less, you qualify for our base pricing. If you are looking to acquire a businesses larger than $25M, please contact us.'
                  placement='right'
                >
                  {circleIcon}
                </Tooltip>
              </label>

              <div className='input-price list-price'>
                <div>
                  <Slider
                    aria-label='Always visible'
                    defaultValue={300000}
                    getAriaValueText={valuetext}
                    valueLabelDisplay='auto'
                    marks={marks}
                    // value={price}
                    step={100000}
                    min={300000}
                    max={25000000}
                    valueLabelDisplay={'on'}
                    onChange={(e) => setPrice(() => e.target.value)}
                    getAriaValueText={valueLabelFormat}
                    valueLabelFormat={valueLabelFormat}
                  />
                </div>
              </div>
              <br />
              <div>
                <div>
                  <Box sx={{ minWidth: 120 }}>
                    <div className='checkBoxesParentBox'>
                      <InputLabel
                        className='label-duetimiline'
                        variant='standard'
                        htmlFor='uncontrolled-native'
                      >
                        Optional Add-ons
                        <Tooltip title='Your Start to Finish Plan includes an unlimited number of our Preliminary Vetting and Live Verification Reports. If you would like to add additional features to your Start to Finish Plan, you may select them below and your quote will be adjusted accordingly.' placement='right'>
                          {circleIcon}
                        </Tooltip>
                      </InputLabel>

                      <div>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={pv}
                              onChange={handleCheckboxChange}
                              name='pv'
                              disabled
                            />
                          }
                          label='Preliminary Vetting'
                        />
                        <Tooltip title='Your Start to Finish Plan includes an unlimited number of Preliminary Vetting reports by default, geared toward providing you with an analysis of your target acquisition pre-LOI. Individually, these are priced at $750 per report.' placement='right'>
                          {circleIcon}
                        </Tooltip>
                      </div>
                      <div>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={lvp}
                              onChange={handleCheckboxChange}
                              name='lvp'
                              disabled
                            />
                          }
                          label='Live Verification Report'
                        />
                        <Tooltip
                          title='Your Start to Finish Plan includes an unlimited number of Live Verification Reports by default, geared toward providing you with comprehensive due diligence for your target acquisition post-LOI. Individually, these start at $5,900.'
                          placement='right-start'
                        >
                          {circleIcon}
                        </Tooltip>
                      </div>
                      <div>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={tsa}
                              onChange={handleCheckboxChange}
                              name='tsa'
                            />
                          }
                          label='Codebase & Tech Stack Analysis'
                        />
                        <Tooltip
                          title='If you are fairly certain your target acquisition will be a SaaS or software business, you may add this as an add-on, which will provide you with an unlimited number of Codebase & Tech Stack Analysis reports as part of the Start to Finish Plan. If you are unsure, we recommend purchasing this individually post-LOI as a more affordable option.'
                          placement='right-start'
                        >
                          {circleIcon}
                        </Tooltip>
                      </div>
                      <div>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={qoe}
                              onChange={handleCheckboxChange}
                              name='qoe'
                            />
                          }
                          label='Quality of Earnings'
                        />
                        <Tooltip
                          title='If you are fairly certain you wil need a Quality of Earnings for your target acquisition, you may add this as an add-on, which will provide you with an unlimited number of QoE reports as part of the Start to Finish Plan. If you are unsure, we recommend purchasing this individually post-LOI as a more affordable option.'
                          placement='right-start'
                        >
                          {circleIcon}
                        </Tooltip>
                      </div>
                      <div>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={df}
                              onChange={handleCheckboxChange}
                              name='df'
                            />
                          }
                          label='Deal Flow'
                        />
                        <Tooltip title='This optional add-on will allow our team to conduct your search for you based on your target criteria through our public broker network. This does not include proprietary outreach. We recommend this if you do not have the time or ability to search yourself. Otherwise, we recommend forgoing this add-on to keep the Start to Finish Plan more affordable.' placement='right-start'>
                          {circleIcon}
                        </Tooltip>
                      </div>
                    </div>
                  </Box>
                </div>
              </div>
            </div>
          )}
        </div>

        <button onClick={handleCanculate}>Generate Quote</button>
      </div>
    </div>
  )
};

export default ComissionCalculator;
